class ScriptLoader {
    constructor() {
        window.__landrCoreLoadedScripts = window.__landrCoreLoadedScripts || {};
        this.loadedScripts = window.__landrCoreLoadedScripts;
    }
    /**
     * Returns a promise that is resolved only when all the scripts are fully loaded
     * @param {string[]} scriptUrls Array of URLs to load
     * @returns {Promise}
     */
    loadScripts(scriptUrls) {
        scriptUrls = scriptUrls || [];
        return Promise.all(scriptUrls.map((scriptUrl) => this.loadScript(scriptUrl)));
    }
    /**
     * Returns a promise that is resolved when the script is fully loaded
     * @param {string} scriptUrl URL of the script to load
     * @returns {Promise}
     */
    loadScript(scriptUrl) {
        let loadedScript = this.loadedScripts[scriptUrl];
        if (!loadedScript) {
            loadedScript = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = scriptUrl;
                script.addEventListener('load', resolve, false);
                script.addEventListener('error', reject, false);
                script.addEventListener('abort', reject, false);
                const firstScriptOnPage = window.document.getElementsByTagName('script')[0];
                firstScriptOnPage.parentNode.insertBefore(script, firstScriptOnPage);
            });
            this.loadedScripts[scriptUrl] = loadedScript;
        }
        return loadedScript;
    }
}

export { ScriptLoader };
